<template>
  <BreadCrumb :PageTitle="t('settings.editOrganization')" />
  <CoverImage />
  <UpdateOrganization />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import CoverImage from "../../components/Settings/CoverImage.vue";
import UpdateOrganization from "../../components/Settings/organizationedit/updateOrganization.vue";

export default defineComponent({
  name: "ChangePasswordPage",
  components: {
    BreadCrumb,
    CoverImage,
    UpdateOrganization,
  },
  setup() {
      const { t } = useI18n();
      return {
      t,
    };
  }
});
</script>